import styled from 'styled-components';

import Clock from './Clock';
import Moon from 'components/common/Moon';

const Wrapper = styled.div`
  font-size: 17px;
`;

const TopBar = styled.div`
  height: 7px;
  background-color: #8d8d8d;
`;

const HeaderContainer = styled.header`
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const TimeInfoBox = styled.div`
  display: flex;
  align-items: center;
`;

const Header = () => {
  return (
    <Wrapper>
      <TopBar></TopBar>
      <HeaderContainer>
        <img src="/assets/now/owl_logo_60.png" alt="logo" />
        <TimeInfoBox>
          <Clock />
          <Moon />
        </TimeInfoBox>
      </HeaderContainer>
    </Wrapper>
  );
};

export default Header;
